<template>
  <div>
    <div class="page-header">
      <div class="pageTitle">
        <div class="pageName">SNMP Config</div>
      </div>
    </div>
    <div class="row">
      <p style="margin: 20px 15px 10px">
        {{ "This page shows the config of SNMP." }}
      </p>
    </div>
    <div>
      <tabs v-model="activeIndex">
        <!--SNMP community-->
        <pane label="Community">
          <snmp-community></snmp-community>
        </pane>
        <!--SNMP trap-->
        <pane label="Trap Config">
          <snmp-trap></snmp-trap>
        </pane>
      </tabs>
    </div>
  </div>
</template>

<script>
import Tabs from "@/components/Tabs.vue"
import Pane from "@/components/Pane.vue"
import SnmpCommunity from "@/views/SnmpCommunity.vue"
import SnmpTrap from "@/views/SnmpTrap.vue"

export default {
  components: {
    Tabs,
    Pane,
    SnmpCommunity,
    SnmpTrap,
  },
  data() {
    return {
      activeIndex: 0,
    }
  },
}
</script>

